class CoverageArea {
	constructor(props) {
		console.log('CoverageArea::constructor(%o)', props);
		let _that = this;
		_that.page_ajax = {
			coverage_area: {}
		};
		_that.page_timers = {
			coverage_area: {}
		};
		_that.findPlanButton = document.getElementById('find_plan');
		_that.holder = document.getElementById('coverage_area_holder');
		_that.response_spinner = _that.holder.querySelector('#coverage_area_response_spinner');
		_that.response_message = _that.holder.querySelector('#coverage_area_response_message');
		_that.coverage_area_response_holder = _that.holder.querySelector('#coverage_area_response_holder');
		_that.selected_area_code = null;
		_that.coverage_area_setting_id = null;
		_that.has_migration = false;
		_that.valid = false;
		_that.callbacks = {};
		_that.auto_check_on_input = false;
		_that.auto_validate_on_change = false;
		_that.detect_address_change = true;
		_that = Object.assign(this, props);

		_that.select_fields = _that.holder.querySelectorAll('select[name^="coverage_area"]');
		_that.input_fields = _that.holder.querySelectorAll('input[name^="coverage_area"]');

		if (_that.input_fields) {
			_that.input_fields.forEach(selector => {
				selector.addEventListener('input', (e) => {
					const form_group = selector.closest('.form-group');
					form_group.classList.remove('has-error');
					const help_block = form_group.querySelector('.control-label');
					if (help_block) {
						help_block.remove();
					}
					if (_that.auto_validate_on_change) {
						let is_valid = _that.validateAddressFields(false);
						_that.emitCallback('fields_validity', is_valid);
					}
					if (_that.detect_address_change) {
						_that.addressChange();
					}
				});
			});
		}
		if (_that.select_fields) {
			_that.select_fields.forEach(selector => {
				if (selector.name !== 'coverage_area[selected_area_code]') {
					selector.addEventListener('change', (e) => {
						const form_group = selector.closest('.form-group');
						form_group.classList.remove('has-error');
						const help_block = form_group.querySelector('.control-label');
						if (help_block) {
							help_block.remove();
						}
						if (_that.auto_validate_on_change) {
							let is_valid = _that.validateAddressFields(false);
							_that.emitCallback('fields_validity', is_valid);
						}
						if (_that.detect_address_change) {
							_that.addressChange();
						}
					});
				}
			});
		}

		_that.emitCallback('init');

		if (!_that.valid) {
			_that.addressChange();
		}
	}


	doAjax(url, data) {
		console.log('CoverageArea::doAjax(%o, %o)', url, data);
		let _that = this;
		data.has_migration = _that.has_migration ? 1 : 0;

		return new Promise((resolve, reject) => {
			_that.emitCallback('do_ajax', data);
			_that.page_ajax.covereage_area = $.ajax({
				url: url,
				type: 'post',
				dataType: 'json',
				data: data,
				success: function (response) {
					resolve(response);
				},
				error: (jqXHR, textStatus, errorThrown) => {
					if (jqXHR.status === 403) {
						// session expired, force page reload
						window.location.reload();
						return;
					}
					reject(textStatus);
				}
			});
		});
	}

	addElementLabel(input, message, class_name = 'has-error') {
		const form_group = input.closest('.form-group');
		if (form_group) {
			form_group.classList.add(class_name);

			let control_label = form_group.querySelector('label');

			if (!control_label) {
				control_label = document.createElement('label');
			}
			control_label.classList.add('control-label');
			control_label.innerHTML = message;
			form_group.appendChild(control_label);
		}
	}

	checkAddress(manual_trigger = false) {
		let _that = this;

		clearTimeout(_that.page_timers.covereage_area);
		if (_that.page_ajax.covereage_area) {
			_that.page_ajax.covereage_area.abort();
		}

		const {
			supplier,
			address,
			city,
			state,
			zip5
		} = _that.getCoverageFields();

		const ajax_url = _that.coverage_area_setting_id !== null
			? url('/account/process_checkout')
			: url('/process_coverage')
		;

		_that.validateAddressFields(manual_trigger || !_that.auto_check_on_input);

		const ajax_data = {
			action: _that.coverage_area_setting_id !== null ? 'check_us_zip_coverage' : 'check_zip_coverage',
			address: address ? address.value : '',
			city: city ? city.value : '',
			state: state ? state.value : '',
			zip: zip5 ? zip5.value : '',
			supplier: supplier ? supplier.value : ''
		};

		if (ajax_data.address !== '' && ajax_data.city !== '' && ajax_data.state !== '' && validate_us_zip(ajax_data.zip)) {
			_that.coverage_area_response_holder.classList.remove('hidden');
			_that.coverage_area_response_holder.innerHTML = '<svg class=\'spinner\' viewBox=\'0 0 50 50\'><circle class=\'path\' cx=\'25\' cy=\'25\' r=\'20\' fill=\'none\' stroke-width=\'5\'></circle></svg>';

			_that.doAjax(ajax_url, ajax_data)
				.then(response => {
					response.address_parts = {
						address: ajax_data.address,
						city: ajax_data.city,
						state: ajax_data.state,
						zip: ajax_data.zip
					};

					_that.coverage_area_response_holder.innerHTML = response.html;

					if (response.valid) {
						_that.emitCallback('valid');
						if (_that.findPlanButton) {
							_that.findPlanButton.classList.remove('d-none');
						}
					} else {
						_that.emitCallback('invalid');
					}

					_that.emitCallback('callback', response);
				})
				.catch(response => {
					let error_message = '';
					if (response !== 'abort') {
						console.log(response);
						error_message = 'An error has occurred';
					}

					_that.coverage_area_response_holder.innerHTML = error_message;

					_that.emitCallback('invalid');
					_that.emitCallback('callback', response);
				})
			;
		}
	}

	getCoverageFields() {
		return {
			supplier: this.holder.querySelector('input[name="coverage_area[supplier]"]'),
			address: this.holder.querySelector('input[name="coverage_area[address]"]'),
			city: this.holder.querySelector('input[name="coverage_area[city]"]'),
			state: this.holder.querySelector('select[name="coverage_area[state]"]'),
			zip5: this.holder.querySelector('input[name="coverage_area[zip]"]')
		};
	}

	validateAddressFields(show_errors = false) {
		const {address, city, state, zip5} = this.getCoverageFields();
		let is_valid = true;

		if (address.value.trim() === '') {
			is_valid = false;
			if (show_errors) this.addElementLabel(address, it('MANDATORY_FIELD'));
		}

		if (city.value.trim() === '') {
			is_valid = false;
			if (show_errors) this.addElementLabel(city, it('MANDATORY_FIELD'));
		}

		if (state.value.trim() === '') {
			is_valid = false;
			if (show_errors) this.addElementLabel(state, it('MANDATORY_FIELD'));
		}

		if (zip5.value.trim() === '') {
			is_valid = false;
			if (show_errors) this.addElementLabel(zip5, it('MANDATORY_FIELD'));
		} else if (!validate_us_zip(zip5.value.trim())) {
			is_valid = false;
			if (show_errors) this.addElementLabel(zip5, it('INVALID_ZIP_CODE'));
		}

		return is_valid;
	}

	addressChange() {
		console.log('CoverageArea::addressChange()');
		let _that = this;
		_that.emitCallback('invalid');

		clearTimeout(_that.page_timers.covereage_area);
		if (_that.page_ajax.covereage_area) {
			_that.page_ajax.covereage_area.abort();
		}

		if (_that.auto_check_on_input) {
			_that.page_timers.covereage_area = setTimeout(() => {
				_that.checkAddress();
			}, 700);
		}
	}

	emitCallback(name, params = null) {
		let _that = this;

		if (typeof _that.callbacks[name] === 'function') {
			try {
				if (name === 'callback') {
					const old_response_message = `${params.address_parts.city}, ${params.address_parts.state}, ${params.address_parts.zip}`;
					if (params.valid) {
						const combined_message = [];
						for (let network_type in params.signal) {
							if (params.signal.hasOwnProperty(network_type)) {
								combined_message.push(`${network_type.toUpperCase()}-${params.signal[network_type]['signal_type']}`);
							}
						}
						trackEvent('Coverage Check', combined_message.join('_'), old_response_message);
						// Track if the user has valid coverage
						dataLayerPush({'event': 'hasCoverage'});
					} else {
						trackEvent('Coverage Check', 'INVALID_COVERAGE', old_response_message);
					}
				}
				console.log('CoverageArea::emitCallback(%o, %o)', name, params);
				_that.callbacks[name].call(this, params);
			} catch (e) {
				console.log(e);
			}
		} else {
			console.log('CoverageArea::emitCallback(%o, %o) not defined', name, params);
		}
	}
}
